import React, { useState, useEffect } from "react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import logo from "../assets/logodan.png";

const MainNavbar = ({ activeLink }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleScroll = () => setIsSticky(window.pageYOffset > 462);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <Navbar
      light
      expand="md"
      className={`navbar-wrapper ${isSticky || isMobile ? "sticky-top" : ""}`}
    >
      <NavbarToggler onClick={toggle} />
      {isMobile && (
        <>
          <div
            style={{
              color: "#fff",
              display: "flex",
              gap: "5px",
              alignItems: "center",
              textTransform: "uppercase",
            }}
          >
            <img
              src={logo}
              alt="Arig bank"
              style={{ paddingBottom: "5px", width: "40px" }}
            />
            Ариг банк
          </div>
          <div style={{ width: "45px" }}></div>
        </>
      )}
      <Collapse isOpen={isOpen} navbar>
        <Nav navbar>
          {[
            { href: "/", label: "Урамшууллын эрх шалгах", key: "default" },
            { href: "/form", label: "Данс нээлгэх", key: "form" },
            { href: "/info", label: "100 сая ₮ аяны тухай", key: "info" },
            { href: "/news", label: "Мэдээ", key: "news" },
            { href: "/live", label: "Бичлэг", key: "live" },
            { href: "/savings", label: "Хадгаламжийн төрлүүд", key: "savings" },
            {
              href: "/locations",
              label: "Салбаруудын байршил",
              key: "locations",
            },
          ].map(({ href, label, key }) => (
            <NavItem
              key={key}
              className={
                activeLink === key || (key === "default" && !activeLink)
                  ? "active"
                  : ""
              }
            >
              <NavLink href={href} className="navbar-text">
                {label}
              </NavLink>
            </NavItem>
          ))}
        </Nav>
      </Collapse>
    </Navbar>
  );
};

export default MainNavbar;
